import script from "./TelevisionPackageCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TelevisionPackageCard.vue?vue&type=script&lang=ts&setup=true"

import "./TelevisionPackageCard.vue?vue&type=style&index=0&id=0c6458fb&lang=scss"

const __exports__ = script;

export default __exports__